<template>
  <div id="story" v-if="showWindow">
      <vs-popup classContent="popup-example" title="Update document" :active.sync="popUps.updateDoc">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Exp date
          <datepicker format="yyyy-MM-dd 00:00:00" placeholder="Select Date" v-model="params.exp_date1"></datepicker>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Deal Name 
          <v-select :closeOnSelect="true" v-model="params.deal_name1" @input="getSelectData()" label="deal_desc" :options="dealName" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Service 
          <v-select :closeOnSelect="true" v-model="params.biz_get_services" label="s_name" :options="bizService" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          b_name 
          <v-select :closeOnSelect="true" v-model="params.biz_get_ben" label="b_name" :options="bizBen" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Type
          <v-select :closeOnSelect="true" v-model="params.biz_get_trantype" label="t_desc" :options="bizType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Accounts
          <v-select :closeOnSelect="true" v-model="params.biz_get_accounts" label="acc_name" :options="bizAccounts" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Amount
          <vs-input class="inputx w-full" v-model="params.amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Currency
          <v-select :closeOnSelect="true" v-model="params.biz_get_currencies" label="code" :options="bizCurrency" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Status
          <v-select :closeOnSelect="true" v-model="params.biz_get_statuses" label="st_name" :options="bizStatus" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Ref1
          <vs-input class="inputx w-full" v-model="params.tran_ref1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Notes
          <vs-input class="inputx w-full" v-model="params.transfer_notes1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Comments
          <vs-input class="inputx w-full" v-model="params.comments1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData()" color="primary" type="filled">Update</vs-button>
        </div>
      </div>
    </vs-popup>
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      :buttons="buttons"
      :pop-ups="popUps"
      >
    </table-view>
  </div>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import tableView from '../../components/tableView';
import dealName from '../../../resources/deal_name.json';
import bizStatus from '../../../resources/biz_get_statuses.json';
import bizType from '../../../resources/biz_get_trantype.json';
import bizCurrency from '../../../resources/biz_get_currencies.json';
export default {
  components: {   
    tableView,
    vSelect,
    Datepicker
  },
  data() {
    
    let data = {
      params:{},
      dealName: dealName,
      bizStatus: bizStatus,
      bizCurrency:bizCurrency,
      bizType:bizType,
      bizAccounts:[],
      bizBen:[],
      bizService:[],
      endPoint:'story',
      filters: {},
      buttons:{
          updateDoc: true
      },
      popUps:{
          updateDoc: false
      }
    }
    data.columnDefs= [
        {
          headerName: 'amount',
          field: 'amount',
          width: 125,
          filter: true,
        },
        
        {
          headerName: 'Beneficiary',
          field: 'beneficiary',
          filter: true,
          width: 175,
          type: ['dateColumn', 'nonEditableColumn'],
        },
        {
          headerName: 'Client',
          field: 'client',
          filter: true,
          width: 125,
        },
        {
          headerName: 'Comments',
          field: 'comments',
          filter: true,
          width: 250,
        },
        {
          headerName: 'created_at',
          field: 'created_at',
          filter: true,
          width: 150,
        },
        {
          headerName: 'Currency',
          field: 'currency',
          filter: true,
          width: 150,
        },
        {
          headerName: 'deal',
          field: 'deal',
          filter: true,
          width: 125,
        },
        {
          headerName: 'department',
          field: 'department',
          filter: true,
          width: 125,
        },
        {
          headerName: 'id',
          field: 'id',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'last_updated',
          field: 'last_updated',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'payment_account',
          field: 'payment_account',
          filter: true,
          width: 125,
        },
        {
          headerName: 'payment_date',
          field: 'payment_date',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'project',
          field: 'project',
          filter: true,
          width: 125,
        },
        {
          headerName: 'service',
          field: 'service',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'status',
          field: 'status',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'timestamp',
          field: 'timestamp',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'tl_id',
          field: 'tl_id',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'tran_reference',
          field: 'tran_reference',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'tran_type',
          field: 'tran_type',
          width: 125,
        },
        {
          headerName: 'transfer_notes',
          field: 'transfer_notes',
          width: 125,
        },
        
      ]
    return data;
  },
  methods:{
    sendData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('action', 'insert-income');
      params.append('biz_get_accounts', this.params.biz_get_accounts.acc_name);
      params.append('biz_get_currencies', this.params.biz_get_currencies.code);
      params.append('biz_get_services', this.params.biz_get_services.s_name);
      params.append('biz_get_statuses', this.params.biz_get_statuses.st_name);
      params.append('biz_get_trantype', this.params.biz_get_trantype.t_desc);
      params.append('biz_get_ben', this.params.biz_get_ben.b_name);
      params.append('deal_name1', this.params.deal_name1.deal_name);
      params.append('tran_ref1', this.params.tran_ref1);
      params.append('transfer_notes1', this.params.transfer_notes1);
      params.append('comments1', this.params.comments1);
      params.append('amount', this.params.amount);
      params.append('exp_date1', this.params.exp_date1);      
      this.$vs.loading();
      axios.post("/api/business",params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data==='undefined')
            data.data = data.success;
        if(data.data[0].out1==='done!'){
            that.popUps.updateDoc = false;
            that.params = {};
            that.openAlert('success','Success',data.data[0].out1);
        }
        else
            that.openAlert('danger','Failed',data.data[0].out1); 
      })
      .catch((error) => { that.$vs.loading.close(); that.openAlert('danger','Failed',error[0].out1); })
    },
    getSelectData: function(){
      const params = new URLSearchParams();
        params.append('id', this.params.deal_name1.deal_name);
        let that = this;
        axios.post("/api/income",params)
        .then((response) => {
          that.bizAccounts=response.data.biz_get_accounts;
          that.bizBen=response.data.biz_get_ben;
          that.bizService=response.data.biz_get_services;
        })
        .catch((error) => { console.log('error',error) })
    },
    openAlert(color,title,text) {
        let colorAlert = color;
        this.$vs.notify({
            title: title,
            text: text,
            color: colorAlert
        })
    }
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/business/story'){
        return true;
      }
      return false;
    },
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>
